import Vue from 'vue'
import { createPlatformState, platformAction, platformGetters, platformMutations } from '~/helpers/store'

export default {
  state: () => ({ ...createPlatformState(), membershipCard: null }),
  actions: {
    async fetchCards ({ commit }, filters) {
      await platformAction({
        client: this.$api.payments.cards,
        method: 'getAll',
        params: {
          filter: {
            ...filters,
            purpose: 'TRANSACTIONAL'
          }
        },
        commit,
        logError: this.$logError,
        include: []
      })
    },
    async fetchMembershipCard ({ commit }, venueId) {
      const cards = await platformAction({
        client: this.$api.payments.cards,
        method: 'getAll',
        params: {
          filter: {
            venue: venueId,
            purpose: 'membership'
          }
        },
        commit,
        commitData: false,
        logError: this.$logError,
        include: []
      })

      commit('setMembershipCard', cards)
    },
    async fetchCard ({ commit }, id) {
      await platformAction({
        client: this.$api.payments.cards,
        method: 'get',
        params: id,
        commit,
        logError: this.$logError,
        include: []
      })
    },
    async addCard ({ commit, dispatch, getters }, params) {
      await platformAction({
        client: this.$api.payments.cards,
        method: 'create',
        params: { cardPayload: params.cardPayload, form: { id: params.formId } },
        commit,
        logError: this.$logError
      })
      if (!getters.failed) {
        dispatch('fetchCards', params.filter)
      }
    },
    async setCardAsPrimary ({ commit, dispatch }, params) {
      await platformAction({
        client: this.$api.payments.cards,
        method: 'update',
        params: {
          id: params.id,
          is_primary: true
        },
        commit,
        logError: this.$logError
      })
      dispatch('fetchCards', params.filter)
    },
    async deleteCard ({ commit, getters }, params) {
      await platformAction({
        client: this.$api.payments.cards,
        method: 'delete',
        params: params.id,
        commit,
        logError: this.$logError,
        commitData: false
      })
      if (!getters.failed) {
        commit('removeCard', params.id)
      }
    }
  },
  getters: {
    ...platformGetters,

    membershipCard (s) {
      return s.membershipCard
    }
  },
  mutations: {
    ...platformMutations,
    clearCards (s) {
      s.data = {}
    },
    removeCard (s, id) {
      const newData = Object.assign({}, s.data)
      delete newData[id]
      Vue.set(s, 'data', newData)
    },
    setMembershipCard (s, cards) {
      // Since we filter by venue in the request, we'll only ever get at most one card since we can only have one per gateway
      if (cards.length) {
        s.membershipCard = cards[0]
      } else {
        s.membershipCard = null
      }
    }
  }
}
